import React, {Dispatch, MutableRefObject, SetStateAction, useEffect, useRef, useState} from "react";
import {ReactComponent as IconCalendar} from "../../images/icon-calendar-black.svg";
import DatePicker from "react-datepicker";
import { ko } from 'date-fns/esm/locale';
import {DateHelper} from "../../helper/DateHelper";
import moment from "moment";
interface IProps {
    value?: any;
    name?: string;
    onChange?: Dispatch<SetStateAction<any>>;
    className?: string;
    onClick?: Dispatch<SetStateAction<any>>;
    readOnly?: boolean;
    type?: string;
    disabled?: boolean;
    onBlur?: Dispatch<SetStateAction<any>>;
    placeholder?:string;
    calendar?: Dispatch<SetStateAction<any>>;
    defaultValue?: any | null;
    fitWidth?: boolean;
    setter?:  Dispatch<React.SetStateAction<Date | null>>;
    style?: object
}

export default function BMCDatePicker2(props: IProps) {
    const calenderInputRef = useRef<any>();
    const [initDate, setInitDate] = useState<any>(new Date());
    const [type, setType] = useState<string>(props.type || '')
    function fn_change(e: Date) {
        // @ts-ignore
        let dateStr : string = DateHelper.format(e)
        // @ts-ignore
        var oriTime : number = DateHelper.parse(dateStr)?.getTime()
        var date = new Date(oriTime + (1000 * 60 * 60 * 10))
        setInitDate(date)
        if(props.setter){
            props.setter(date)
        }
        if(props.onChange){
            props.onChange({target:{name:props.name, value: date}});
        }
    }
    useEffect(() => {
        if(props.defaultValue){
            if(props.defaultValue instanceof Date){
                setInitDate(props.defaultValue)
            }
            else if(typeof props.defaultValue === 'string' ){
                try{
                    setInitDate(moment(props.defaultValue, 'YYYY-MM-DD').toDate())
                }catch (e){
                    console.error(e)
                }

            }
        }else{
            setInitDate(null)
        }
    }, [props.defaultValue])
    return (
        <div style={props.style || {}} className={"bmc-box-input date px-2"+(type == 'hidden' ? ' d-none' : '')+(props.disabled ? ' disabled' : '')  + (props.fitWidth ? ' fitWidth ' : '')}>
            <DatePicker
                disabled={props.disabled}
                dateFormatCalendar="yyyy년 MM월"
                name={props.name}
                dateFormat='yyyy-MM-dd'
                locale={ko}
                autoComplete={'off'}
                className={'form-control bmc-date-picker border-0'} selected={initDate} onChange={fn_change} ref={calenderInputRef} />
            <IconCalendar className='cursor-pointer' onClick={(e)=> {
                if(calenderInputRef.current) {
                    calenderInputRef.current.setOpen(true)
                }
            }} />
        </div>
    )
}
